const DOCUMENT_VERSION_STATUSES = {
  draft: 'draft',
  awaitingApproval: 'awaiting_approval',
  approved: 'approved',
  effective: 'effective',
  retired: 'retired',
  rejected: 'rejected',
  draftReview: 'draft_review',
  reviewed: 'reviewed',
};

const getTagVersion = (status) => {
  switch (status) {
    case DOCUMENT_VERSION_STATUSES.reviewed:
    case DOCUMENT_VERSION_STATUSES.draftReview:
    case DOCUMENT_VERSION_STATUSES.draft:
    case DOCUMENT_VERSION_STATUSES.approved:
      return 'info';
    case DOCUMENT_VERSION_STATUSES.awaitingApproval:
    case DOCUMENT_VERSION_STATUSES.rejected:
      return 'warning';
    case DOCUMENT_VERSION_STATUSES.effective:
      return 'success';
    case DOCUMENT_VERSION_STATUSES.retired:
      return 'danger';
    default:
      return 'regular';
  }
};

const getDocumentVersionVersion = ({ major, minor, draftRevision, status }) => {
  let version = `v${major}.${minor}`;

  if (
    [
      DOCUMENT_VERSION_STATUSES.draft,
      DOCUMENT_VERSION_STATUSES.reviewed,
      DOCUMENT_VERSION_STATUSES.draftReview,
    ].includes(status)
  ) {
    version += draftRevision ? `.${draftRevision}` : '.0';
  }

  return version;
};

export default class DocumentModel {
  constructor({ documentData }) {
    this._documentData = documentData || {};
  }

  url = () => {
    return this._documentData?.revision.url;
  };

  watermarkOptions = () => {
    return this._documentData?.revision.watermarkOptions;
  };

  fileExtension = () => {
    return this._documentData?.revision.fileExtension;
  };

  name = () => {
    return this._documentData?.name;
  };

  currentStep = () => {
    const { externalAssigneeId } = this._documentData;
    const currentWorkflowStep = this._documentData?.workflow?.workflowSteps?.find(
      (workflowStep) => workflowStep.assigneeId === externalAssigneeId && workflowStep.isCurrent
    );
    return currentWorkflowStep?.step;
  };

  currentWorkflowStepStatus = () => {
    const { externalAssigneeId } = this._documentData;
    const currentWorkflowStep = this._documentData?.workflow?.workflowSteps?.find(
      (workflowStep) => workflowStep.assigneeId === externalAssigneeId && workflowStep.isCurrent
    );
    return currentWorkflowStep?.status;
  };

  workflow = () => {
    return this._documentData?.workflow;
  };

  workflowSteps = () => {
    return this._documentData?.workflow?.workflowSteps;
  };

  documentStatus = () => {
    const { major, minor, draftRevision, status } = this._documentData;
    const version = getDocumentVersionVersion({ major, minor, draftRevision, status });

    return `${version}: ${status?.toUpperCase().replace('_', ' ')}`;
  };

  documentName = () => {
    const { name, keyId } = this._documentData;
    return `${keyId}: ${name}`;
  };

  statusTagVariant = () => {
    const { status } = this._documentData;
    const res = getTagVersion(status);
    return res;
  };

  workflowType = () => {
    return this._documentData?.workflow?.type;
  };

  workflowSubType = () => {
    return this._documentData?.workflow?.subtype;
  };
}
